import { render, staticRenderFns } from "./IpStats.vue?vue&type=template&id=6eae6d78&scoped=true"
import script from "./IpStats.vue?vue&type=script&lang=js"
export * from "./IpStats.vue?vue&type=script&lang=js"
import style0 from "./IpStats.vue?vue&type=style&index=0&id=6eae6d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eae6d78",
  null
  
)

export default component.exports